var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'row-format': _vm.format === 'row'}},[_c('div',{staticClass:"form-label label"},[_vm._t("label")],2),_vm._v(" "),_c('div',[_vm._t("control")],2),_vm._v(" "),_c('div',{staticClass:"form-label footer"},[_vm._t("footer")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }